"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dictionary = exports.default = void 0;
const placeholderPattern = /{(.*?)}/g;
const dictionary = function (originalText, dictionary, defaultValue) {
  if (typeof originalText !== "string") return originalText;
  const text = originalText.replaceAll("{{", "{").replaceAll("}}", "}");
  const placeholders = Array.from(text.matchAll(placeholderPattern));
  return placeholders.reduce(function (acc, placeholder) {
    var _dictionary$key;
    const key = placeholder[1].trim();
    const value = (_dictionary$key = dictionary[key]) !== null && _dictionary$key !== void 0 ? _dictionary$key : defaultValue;
    if (value === undefined) {
      return acc;
    }
    return acc.replace(new RegExp(placeholder[0], "g"), value.toString());
  }, text);
};
exports.dictionary = dictionary;
var _default = exports.default = dictionary;